export const UNIDENTIFIED_CLIENT = 'Unidentified client';
